<script>
import { createNamespacedHelpers } from 'vuex'
import actions from '@/room-display/store/actions'
import helper from '@/components/helpers/errorModal'
const { mapActions } = createNamespacedHelpers('roomDisplay')

export default {
  name: 'ErrorModal',
  props: {
    error: {
      type: Object
    }
  },
  render: function () {
    return null
  },
  created () {
    this.showErrorModal()
  },
  methods: {
    ...mapActions(Object.keys(actions)),
    showErrorModal () {
      if (!this.error) {
        return
      }
      const { errorFactoryModal } = helper()
      errorFactoryModal(this.error, this.translate)
      // eslint-disable-next-line no-undef
      $('#modal-error').on('hide.bs.modal', () => {
        this.clearError()
      })
    }
  }
}
</script>
